'use client'
import { useState } from 'react'
import { Cancel01Icon } from '@/utils/icons'
export default function CautionBanner (): JSX.Element {
  const [remove, setRemove] = useState<boolean>(false)
  return (
    <>
      {!remove
        ? (
          <section
            className='flex font-regular justify-center items-center p-1 bg-primary/50 gap-5'
          >
            <p className='text-white/80 text-center'>Always verify you're on the correct website:  <span className='font-clash text-white'> https://app.bubblefi.xyz </span> Bookmark the URL</p>
            {/* <Cancel01Icon
              width={20}
              onClick={() => setRemove(true)}
              className='cursor-pointer text-white'
            /> */}
          </section>
          )
        : <></>}
    </>
  )
}
